import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getAllChests = async () => {
  // return api.get("/api/chest");
  const res = await api.get(networkConfig.chest.getAllChest);
  return res.data;
};

export const createChest = (data) => {
  return api.post("/api/chest", data);
};

export const deleteChest = (id) => {
  return api.delete(`/api/chest/${id}`);
};

export const toggleChestStatus = (id, value) => {
  return api.patch(`/api/chest/${id}/active/${value}`);
};

// export const updateChest = ()
